import React from 'react'
import { View, Text } from 'react-native'
import { Button } from '../ui/Button'

export interface SafetySubmission {
  username: string
  blockAction: 'blocked' | 'unblocked' | null
  reported: boolean
  flagged: boolean
  gameId?: string
}

export function ReportConfirmation({ submission, onLobby, onGame, onTickets }: { submission: SafetySubmission; onLobby: () => void; onGame?: () => void; onTickets?: () => void }) {
  return <View className="bg-paper border-2 border-olive rounded-xl p-4 gap-4">
    <Text accessibilityRole="header" className="font-stencil text-ink text-xl">{submission.reported ? 'Report submitted' : submission.blockAction === 'unblocked' ? 'User unblocked' : 'User blocked'}</Text>
    {submission.blockAction && <Text className="font-typed text-ink">@{submission.username} has been {submission.blockAction}.</Text>}
    {submission.blockAction === 'blocked' && <Text className="font-typed text-ink-soft">They can no longer send you direct messages or invites, or find you in game-invite searches.</Text>}
    {submission.reported && <>
      <Text className="font-typed text-ink">Your {submission.flagged ? 'inappropriate-message report' : 'report'} about @{submission.username} has been sent to the WarCarp team for review.</Text>
      <Text className="font-typed text-ink-soft">Someone from WarCarp may reach out to you for more information.</Text>
    </>}
    {onGame && <Button title="Back to game" onPress={onGame} />}
    {submission.reported && onTickets && <Button title="View Report" variant="secondary" onPress={onTickets} />}
    <Button title="Back to Lobby" variant={onGame ? 'secondary' : 'primary'} onPress={onLobby} />
  </View>
}
